export const KeyCodes = {
  Esc: 'Esc',
  Enter: 'Enter',
  Tab: 'Tab',
};
